"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sidebar_module_scss_1 = __importDefault(require("./sidebar.module.scss"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const FilterContext_1 = require("../../../context/filters/FilterContext");
const filtersHelpers_1 = require("../../../common/utils/filtersHelpers");
const clearLocalStorage_1 = require("../../../common/utils/clearLocalStorage");
const MenuItems = ({ items }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const { setFilters } = (0, FilterContext_1.useFilters)();
    const isActive = (path) => {
        return (location.pathname === path ||
            (location.pathname === '/' && path === '/machines/list') ||
            (path.startsWith('/machines') &&
                location.pathname.startsWith('/machines')) ||
            (path.startsWith('/products') &&
                location.pathname.startsWith('/products')) ||
            (path.startsWith('/refills') &&
                location.pathname.startsWith('/refills')) ||
            (path.startsWith('/orders') && location.pathname.startsWith('/orders')) ||
            (path.startsWith('/advertising') &&
                location.pathname.startsWith('/advertising')));
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("ul", { className: "list-none p-3 m-0", children: items.map((item) => {
                return ((0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("a", { className: `${sidebar_module_scss_1.default.menuItem} ${isActive(item.path) ? sidebar_module_scss_1.default.menuItemActive : ''}`, onClick: () => {
                            (0, clearLocalStorage_1.clearLocalStorage)();
                            setFilters((0, filtersHelpers_1.getInitialFilters)());
                            navigate(item.path);
                        }, children: (0, jsx_runtime_1.jsx)("span", { className: sidebar_module_scss_1.default.menuItemText, children: t(item.label) }) }) }, item.id));
            }) }) }));
};
exports.MenuItems = MenuItems;
